import React from 'react';
import { mission, vision } from '../../data/home';
interface MissionVisionProps {
  tone?: 'ink' | 'coal';
}
export function MissionVision({
  tone = 'coal'
}: MissionVisionProps) {
  const statements = [{
    label: 'Mission',
    text: mission
  }, {
    label: 'Vision',
    text: vision
  }];
  return <section className={`${tone === 'coal' ? 'bg-coal' : 'bg-ink'} py-20 md:py-32`} aria-label="Mission and vision" data-id="element-192" data-mp="3mcqce2zk8bo2">
      <div className="mx-auto grid max-w-[1320px] gap-8 px-5 md:grid-cols-2 md:px-8" data-id="element-193" data-mp="3hdninep15rve">
        {statements.map(statement => <article key={statement.label} className="relative md:pl-3" data-id="element-194" data-mp="3ck123bfqx3ub">
            <div className="absolute bottom-10 left-0 top-10 hidden w-6 rounded-l-2xl bg-flame-deep md:block" aria-hidden="true" data-id="element-195" data-mp="38lbtdw5nkah0" />
            <div className="relative h-full overflow-hidden rounded-[28px] border border-edge bg-steel" data-id="element-196" data-mp="2ymw3fwid3793">
              <h2 className="flex h-16 w-full items-center justify-center bg-flame px-9 font-display text-3xl font-bold uppercase text-ink md:inline-flex md:w-auto md:rounded-br-[28px]" data-id="element-197" data-mp="2tmzwppia51pu">
                {statement.label}
              </h2>
              <p className="m-7 text-center text-xl font-medium leading-relaxed text-chalk md:m-10 md:border-l-4 md:border-flame md:pl-6 md:text-left md:text-2xl" data-id="element-198" data-mp="2rstn3qoapf4s">
                {statement.text}
              </p>
            </div>
          </article>)}
      </div>
    </section>;
}